export const iconFontAwesomeMovingRoute = (
	<i className="fa-solid fa-route"></i>
);
